/* eslint no-param-reassign: "off", no-console: "off" */
const supportStore = {
  state: {
  },
  mutations: {
  },
  actions: {
    // eslint-disable-next-line no-empty-pattern
    async createSalesforceCase({ }, payload) {
      try {
        const res = await fetch('/v2/support/ticket', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        if (!res.ok) throw new Error(await res.text());
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    }
  }
}
export default supportStore;
